import { memoize } from '@/lib/memoize';
import type { Campus, Entity, Ministry, State } from './types';

export type Mutation =
  | {
      type: 'setCampuses';
      data: Campus[];
    }
  | { type: 'setCampus'; data: Campus }
  | { type: 'setMinistries'; data: Ministry[] }
  | { type: 'setMinistry'; data: Ministry }
  | {
      type: 'setEntities';
      data: Entity[];
    };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setCampuses':
      return {
        ...state,
        campuses: {
          data: memoize(action.data),
          loaded: true,
        },
      };
    case 'setCampus':
      return {
        ...state,
        campuses: {
          ...state.campuses,
          data: {
            ...state.campuses.data,
            [action.data.id]: action.data,
          },
        },
      };
    case 'setMinistries':
      return {
        ...state,
        ministries: {
          data: action.data,
          loaded: true,
        },
      };
    case 'setMinistry': {
      const i = state.ministries.data.findIndex(
        (item) => item.id === action.data.id,
      );
      const s = {
        ...state,
        ministries: {
          ...state.ministries,
          data: [...state.ministries.data],
        },
      };
      s.ministries.data[i] = action.data;

      return s;
    }

    case 'setEntities':
      return {
        ...state,
        entities: {
          data: memoize(action.data),
          loaded: true,
        },
      };
    default:
      return state;
  }
}
